<section class="explore-more-section" #sectionRef [@fadeInOnView]="isVisible ? 'visible' : 'hidden'">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center mb-5">
        <h3 class="explore-heading">Explore Our Other Services</h3>
      </div>
    </div>

    <div class="services-grid">
      <!-- Changed <a> to <div> and added (click) to hide the browser status bar link -->
      <div *ngFor="let service of filteredServices" (click)="navigateToService(service.path)" class="service-card">
        <div class="icon-wrapper">
          <img [src]="service.icon" [alt]="service.name" class="service-icon">
        </div>
        <div class="service-info">
          <span class="service-name">{{ service.name }}</span>
        </div>
      </div>
    </div>
  </div>
</section>